class DeferredMediaAbc extends HTMLElement {
  constructor() {
    super();
    this.handlePlayClick = this.handlePlayClick.bind(this);
  }

  connectedCallback() {
    this.playLinks = this.querySelectorAll('a[href="#play_video"], .video_banner_play_btn');
    this.playLinks.forEach((link) => link.addEventListener('click', this.handlePlayClick));
  }

  disconnectedCallback() {
    this.playLinks.forEach((link) => link.removeEventListener('click', this.handlePlayClick));
  }

  handlePlayClick(event) {
    event.preventDefault();
    window.pauseAllMedia();

    if (!this.hasAttribute('loaded')) {
      const template = this.querySelector('template');
      if (!template) return;

      const content = template.content.firstElementChild.cloneNode(true);
      const targetContainer = this.querySelector('.banner__media-container');
      targetContainer.appendChild(content);

      this.setAttribute('loaded', 'true');
      targetContainer.classList.replace('not-loaded', 'loaded');

      const deferredElement = targetContainer.querySelector('video, model-viewer, iframe');
      if (deferredElement) {
        if (deferredElement.nodeName === 'VIDEO' && deferredElement.hasAttribute('autoplay')) {
          deferredElement.play();
        }
        deferredElement.focus();
      }

      this.hideOverlayContent();
    }
  }

  hideOverlayContent() {
    const elementsToHide = this.querySelectorAll('.video-banner-overlay-content');
    elementsToHide.forEach((element) => {
      element.style.display = 'none';
    });
  }
}

customElements.define('deferred-media-abc', DeferredMediaAbc);

function triggerToast(detail) {
  const event = new CustomEvent('toast', {
    detail,
    bubbles: true,
    composed: true,
  });
  document.dispatchEvent(event);
}

/*
 triggerToast({
      title: 'Success',
      message: 'Your action was successful!',
      status: 'success',
      position: 'top-right',
      size: 'small',
      duration: 3000,
    });

    triggerToast({
      title: 'Error',
      message: 'Your action was successful!',
      status: 'error',
      position: 'top-right',
      size: 'large',
      duration: 5000,
    });

    triggerToast({
      title: 'Information',
      message: 'Your action was successful!',
      status: 'error',
      position: 'top-right',
      size: 'large',
      duration: 3000,
    });
    */
/* 
document.addEventListener('DOMContentLoaded', () => {
  const clubLinks = document.querySelectorAll('a[href="#add_club_membership"]');

  clubLinks.forEach((clubLink) => {
    clubLink.addEventListener(
      'click',
      debounce(async (click) => {
        click.preventDefault(); // Use the event parameter

        // Disable all "Join the Club" buttons
        clubLinks.forEach((link) => link.setAttribute('disabled', 'true'));

        const clubProduct = window.__abc?.clubProduct;
        if (
          !clubProduct ||
          !clubProduct.variants?.[0] ||
          !clubProduct.selling_plan_groups?.[0]?.selling_plans?.[0]
        ) {
          console.error('Club product or required data is not defined');
          // Re-enable the buttons if data is missing
          clubLinks.forEach((link) => link.removeAttribute('disabled'));
          return;
        }

        const cartData = window.__abc?.ShopifyCartData.cart;
        if (!cartData) {
          console.error('Cart data is not available');
          clubLinks.forEach((link) => link.removeAttribute('disabled'));
          return;
        }

        // Check if the club product is already in the cart
        const isClubInCart = cartData.items.some((item) => item.id === clubProduct.variants[0].id);

        if (isClubInCart) {
          console.log('Club membership product is already in the cart');
          // Disable all "Join the Club" buttons permanently
          clubLinks.forEach((link) => link.setAttribute('disabled', 'true'));
          alert('You already have a club membership in your cart.');
          return;
        }

        const toSend = {
          id: clubProduct.variants[0].id,
          quantity: 1,
          selling_plan: clubProduct.selling_plan_groups[0].selling_plans[0].id,
        };

        try {
          await addToCart(toSend);
        } catch (error) {
          console.error('Error adding to cart:', error);
        } finally {
          // Re-enable all buttons after fetch completes
          clubLinks.forEach((link) => link.removeAttribute('disabled'));
        }

        console.log('toSend', toSend);
      }, 300)
    );
  });

  async function addToCart(payload) {
    const cart =
      document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const items = Array.isArray(payload) ? payload : [payload];
    const sections = cart?.getSectionsToRender()?.map((section) => section.id) || [];

    const toSend = {
      items,
      sections,
    };

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.headers['Content-Type'] = 'application/json';
    config.body = JSON.stringify(toSend);

    try {
      const response = await fetch(`${routes.cart_add_url}.json`, config);
      const data = await response.json();

      console.log('Cart Add Response:', data);

      if (data.status) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'add_club_membership_btn',
          productVariantId: payload.id,
          errors: data.errors || data.description,
          message: data.message,
        });
        handleError(data.description);
      } else if (!cart) {
        window.location = window.routes.cart_url;
        return;
      }

      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'add_club_membership_btn',
        productVariantId: payload.id,
        cartData: data,
      });

      if (cart) {
        cart.renderContents(data);
        cart.classList.remove('is-empty');
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      throw error;
    }
  }

  function fetchConfig(type) {
    return {
      method: 'POST',
      headers: {
        'Content-Type': type === 'json' ? 'application/json' : 'application/x-www-form-urlencoded',
      },
    };
  }

  function handleError(message) {
    console.error('Cart Error:', message);
  }
});
*/

(function () {
  // Cache all links that trigger club membership addition.
  const clubLinks = document.querySelectorAll('a[href="#add_club_membership"]');

  /**
   * Core functionality to add the club membership to the cart.
   * When called from an event, it will prevent default behavior.
   */
  async function addClubMembershipToCart(event) {
    // If invoked by an event, prevent its default behavior.
    if (event && typeof event.preventDefault === 'function') {
      event.preventDefault();
    }

    // Disable all "Join the Club" buttons.
    //clubLinks.forEach((link) => link.setAttribute('disabled', 'true'));

    const clubProduct = window.__abc?.clubProduct;
    if (
      !clubProduct ||
      !clubProduct.variants?.[0] ||
      !clubProduct.selling_plan_groups?.[0]?.selling_plans?.[0]
    ) {
      console.error('Club product or required data is not defined');
      // Re-enable buttons if data is missing.
      // clubLinks.forEach((link) => link.removeAttribute('disabled'));
      return;
    }

    const cartData = window.__abc?.ShopifyCartData.cart;
    if (!cartData) {
      console.error('Cart data is not available');
      //clubLinks.forEach((link) => link.removeAttribute('disabled'));
      return;
    }

    // Check if the club product is already in the cart.
    const isClubInCart = cartData.items.some((item) => item.id === clubProduct.variants[0].id);
    if (isClubInCart) {
      console.log('Club membership product is already in the cart');
      alert('You already have a club membership in your cart.');
      return;
    }

    const toSend = {
      id: clubProduct.variants[0].id,
      quantity: 1,
      selling_plan: clubProduct.selling_plan_groups[0].selling_plans[0].id,
    };

    try {
      await addToCart(toSend, 'add_club_membership_btn');
    } catch (error) {
      console.error('Error adding to cart:', error);
    } finally {
      // Re-enable buttons after processing.
      //clubLinks.forEach((link) => link.removeAttribute('disabled'));
    }

    //console.log('toSend', toSend);
  }

  /**
   * Helper function to add items to the cart.
   * @param {Object|Array} payload - Item(s) to add to cart
   * @param {string} eventSource - Source identifier for events
   * @param {Object} options - Optional configuration
   * @param {boolean} options.skipDrawer - If true, prevents cart drawer from opening
   * @param {Object} options.attributes - Cart attributes to set (e.g., { GiftNote: 'message' })
   */
  async function addToCart(payload, eventSource, options = {}) {
    const cartElement =
      document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const items = Array.isArray(payload) ? payload : [payload];
    const sections = cartElement?.getSectionsToRender()?.map((section) => section.id) || [];

    const toSend = {
      items,
      sections,
    };

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.headers['Content-Type'] = 'application/json';
    config.body = JSON.stringify(toSend);

    try {
      const response = await fetch(`${routes.cart_add_url}.json`, config);
      const data = await response.json();

      // console.log('Cart Add Response:', data);

      if (data.status) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: eventSource,
          productVariantId: payload.id,
          errors: data.errors || data.description,
          message: data.message,
        });
        handleError(data.description);
        return;
      } else if (!cartElement) {
        window.location = window.routes.cart_url;
        return;
      }

      // If cart attributes are provided, update them after adding items
      if (options.attributes && Object.keys(options.attributes).length > 0) {
        try {
          const updateConfig = fetchConfig('javascript');
          updateConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
          updateConfig.headers['Content-Type'] = 'application/json';
          updateConfig.body = JSON.stringify({ attributes: options.attributes });

          const updateResponse = await fetch(`${routes.cart_update_url}`, updateConfig);
          const updateData = await updateResponse.json();

          // Merge the updated cart data with attributes
          if (updateData && !updateData.status) {
            // Preserve sections from the add response, but update cart data
            data.item_count = updateData.item_count;
            data.items = updateData.items;
            data.attributes = updateData.attributes;
            // Keep the sections from the original add response for rendering
          }
        } catch (updateError) {
          console.error('Error updating cart attributes:', updateError);
          // Continue even if attribute update fails - item was added successfully
        }
      }

      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: eventSource,
        productVariantId: payload.id,
        cartData: data,
      });

      if (cartElement) {
        // If skipDrawer is true, update cart state without rendering/opening the drawer
        if (options.skipDrawer) {
          cartElement.classList.remove('is-empty');
          // Update cart state silently without opening drawer
          // The cart is already updated via the API call, we just skip the UI render
        } else {
          cartElement.renderContents(data);
          cartElement.classList.remove('is-empty');
        }
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      throw error;
    }
  }

  /**
   * Helper: Configure fetch options.
   */
  function fetchConfig(type) {
    return {
      method: 'POST',
      headers: {
        'Content-Type': type === 'json' ? 'application/json' : 'application/x-www-form-urlencoded',
      },
    };
  }

  /**
   * Helper: Log cart error messages.
   */
  function handleError(message) {
    console.error('Cart Error:', message);
  }

  // Attach event listeners to all club membership links.
  clubLinks.forEach((link) => {
    link.addEventListener('click', addClubMembershipToCart);
  });

  // Expose the function globally under window.__abc for use elsewhere.
  window.__abc = window.__abc || {};
  window.__abc.addToCart = addToCart;
  window.__abc.addClubMembershipToCart = addClubMembershipToCart;
})();

// Stamp s_d cart attribute at checkout via hidden form input
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.cart__checkout-button');
 // console.log('btn', btn);
  if (!btn || btn.disabled) return;
  const form = btn.form || document.getElementById(btn.getAttribute('form'));
  //console.log('form', form);
  if (!form) return;
  const input = document.createElement('input');
  //console.log('input', input);
  input.type = 'hidden';
  input.name = 'attributes[_s_d]';
  input.value = '0';
  //console.log('input.value', input.value);
  form.appendChild(input);
  //console.log('form', form);
});

// place this in a <script> tag after your slider HTML,
// or in your section’s JS bundle
